import HorsesCount from './HorsesCount';

export default HorsesCount;
